export enum SortDirections {
  Forward = 'forward',
  Backward = 'backward',
}
